import { render, staticRenderFns } from "./AdminDomains.vue?vue&type=template&id=1def01cb&"
import script from "./AdminDomains.vue?vue&type=script&lang=js&"
export * from "./AdminDomains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports